/**
 * Auth Modal Component
 *
 * Modal for login and signup forms.
 */

import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { LoginForm } from './LoginForm'
import { SignupForm } from './SignupForm'

interface AuthModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  defaultMode?: 'login' | 'signup'
}

export const AuthModal = ({ open, onOpenChange, defaultMode = 'login' }: AuthModalProps) => {
  const [mode, setMode] = useState<'login' | 'signup'>(defaultMode)

  const handleSuccess = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{mode === 'login' ? '로그인' : '회원가입'}</DialogTitle>
          <DialogDescription>
            {mode === 'login'
              ? '로그인하면 AI 요약을 사용할 수 있어요'
              : '계정을 만들면 AI 요약을 사용할 수 있어요'}
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4">
          {mode === 'login' ? (
            <LoginForm onSuccess={handleSuccess} onSwitchToSignup={() => setMode('signup')} />
          ) : (
            <SignupForm onSuccess={handleSuccess} onSwitchToLogin={() => setMode('login')} />
          )}
        </div>

        {/*
          Signing up creates a Firebase account and a preferences document, so the
          terms have to be reachable at the moment of consent — not only from the
          sidebar behind the modal. New tab: losing a half-filled form to read a
          policy is how people give up on signing up.
        */}
        <p className="text-center text-xs text-muted-foreground">
          계속하면{' '}
          <a
            href="/terms/"
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2"
          >
            이용약관
          </a>
          과{' '}
          <a
            href="/privacy/"
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-2"
          >
            개인정보처리방침
          </a>
          에 동의하는 것으로 봅니다.
        </p>
      </DialogContent>
    </Dialog>
  )
}
